import { graphql } from "../gql";
import { useMutation } from "@apollo/client";
import { useCallback } from "react";

const CreateBulk1on1ClassRoomsMutation = graphql(`
  mutation createBulk1on1ClassRooms($intentId: String!) {
    createBulk1on1ClassRooms(intentId: $intentId) {
      planId
      requestId
    }
  }
`);

export function useCreateBulk1on1ClassRooms() {
  const [createBulk1on1ClassRoomsMutation, { loading }] = useMutation(
    CreateBulk1on1ClassRoomsMutation,
  );

  const createBulk1on1ClassRooms = useCallback(
    async (intentId: string) => {
      const res = await createBulk1on1ClassRoomsMutation({
        variables: {
          intentId,
        },
      });

      const result = res.data?.createBulk1on1ClassRooms;
      if (!result) throw new Error("Unable to create bulk 1on1 classrooms");

      return result;
    },
    [createBulk1on1ClassRoomsMutation],
  );

  return {
    loading,
    createBulk1on1ClassRooms,
  };
}
